const initialState: any = {
  user: {
    loading: true,
    loadingState: true,
    data: {},
  },
  symptoms: {
    data: [],
    loading: true,
    loadingState: true,
  },
  departments: {
    data: [],
    loading: true,
    loadingState: true,
  },
  specializations: {
    data: [],
    loading: true,
    loadingState: true,
  },
  sampleTypes: {
    data: [],
    loading: true,
    loadingState: true,
  },
  labTestCategories: {
    data: [],
    loading: true,
    loadingState: true,
  },
  medicineCategories: {
    data: [],
    loading: true,
    loadingState: true,
  },
  medicineSubCategories: {
    data: [],
    loading: true,
    loadingState: true,
  },
  healthcares: {
    data: [],
    loading: true,
    loadingState: true,
  },
  healthcareSubCategories: {
    data: [],
    loading: true,
    loadingState: true,
  },
  doctor: {
    loading: true,
    loadingState: true,
    data: {},
  },
  provider: {
    loading: true,
    loadingState: true,
    data: {},
  },
  doctorRequests: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  activeDoctors: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  patients: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  institution: {
    loading: true,
    loadingState: true,
    data: {},
  },
  institutionRequests: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  activeInstitutions: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  termsAndConditions: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyAndPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  refundPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  platformCharge: {
    loading: true,
    loadingState: true,
    data: {},
  },
  support: {
    loading: true,
    loadingState: true,
    data: {},
  },
  downloadLinks: {
    loading: true,
    loadingState: true,
    data: {},
  },
  logos: {
    loading: true,
    loadingState: true,
    data: {},
  },
  banners: {
    loading: true,
    loadingState: true,
    data: [],
  },

  //seo

  homeSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  aboutSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  serviceSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  contactSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  loginSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  RegisterSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  faqs: {
    data: [],
    loading: true,
    loadingState: true,
  },
  promos: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  healthAdvices: {
    data: [],
    loading: true,
    loadingState: true,
  },
  labTests: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  searchMedicines: {
    loading: true,
    loadingState: true,
  },
  availabilities: {
    loading: true,
    loadingState: true,
    data: [],
  },
  userAppointment: {
    loading: true,
    loadingState: true,
    data: {},
  },
  homeConsultAppointments: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  homeInstanConsultAppointments: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  todayConsultAppointments: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instantConsultAppointments: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  queueAppointments: {
    loading: true,
    loadingState: true,
    data: [],
  },
  consultAppointments: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  consultAppointmentsFilter: {
    date: new Date(),
  },
  consultAppointment: {
    data: {},
    loading: true,
    loadingState: true,
  },
  appointmentConsultDashboard: {
    loading: true,
    loadingState: true,
    data: {},
  },
  pastReports: {
    loading: true,
    loadingState: true,
    data: [],
  },
  messages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  conversations: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  room: {},
  conversation: {},
  modal: {},
  supportMessages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  supports: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  supportRoom: {},
  supportConversation: {},
  incomingCallInfo: {},
  patinets: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteLabTests: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteLabTest: {
    data: {},
    loading: true,
    loadingState: true,
  },
  instituteLabTestPackages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteLabTestPackage: {
    data: {},
    loading: true,
    loadingState: true,
  },
  searchInstituteLabTests: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteHealthServices: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteHealthService: {
    data: {},
    loading: true,
    loadingState: true,
  },
  medicines: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteDoctors: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  instituteHealthProviders: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },

  searchPatients: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalpages: 0,
    totalItems: 0,
  },
  suggestedDoctors: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalpages: 0,
    totalItems: 0,
  },
}

export default initialState
